import { Menu, Transition } from '@headlessui/react'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import classNames from '../../../utils/classNames'
import { getTextColorBasedOnBackground } from '../../Sites/Prerequisites'

export interface DropdownOption {
  key: any
  value: any
  text: any
  icon?: any
  disabled?: boolean
}[]

interface ComponentProps {
  stopPropagation?: boolean
  children: React.ReactNode
  options: Array<DropdownOption>
  autoWidth?: boolean
  preventCloseOnClick?: boolean
  width?: string
  optionPosition?: 'left' | 'center' | 'right'
  secondaryColor?: string
  selectedValue: any
  setValue: (v) => void
}

const BookerDropdownButton = (props: ComponentProps) => {
  const menuButtonRef = useRef(null)

  const [menuOpened, setMenuOpened] = useState(false)
  const [menuButtonPosition, setMenuButtonPosition] = useState(
    menuButtonRef?.current?.getBoundingClientRect()
  )
  const [isHovered, setIsHovered] = useState<Record<string, boolean>>(null)

  useEffect(() => {
    setMenuButtonPosition(menuButtonRef?.current?.getBoundingClientRect())
  }, [menuButtonRef, menuOpened])
  
  return (
    <div className='flex h-full items-center'>
      <Menu
        as='div'
        className='relative inline-block text-left'
        style={{ height: 35 }}
      >
        <div>
          <Menu.Button
            ref={menuButtonRef}
            onClick={() => setMenuOpened((prev) => !prev)}
            className='inline-flex justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'
          >
            {props.children}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter='transition ease-out duration-100'
          enterFrom='transform opacity-0 scale-95'
          enterTo='transform opacity-100 scale-100'
          leave='transition ease-in duration-75'
          leaveFrom='transform opacity-100 scale-100'
          leaveTo='transform opacity-0 scale-95'
        >
          <Menu.Items
            style={{
              width: props.width,
            }}
            
            className={classNames(
              "fixed xs:max-h-60 overflow-y-auto inset-0 xs:inset-auto xs:absolute xs:top-9 z-50 xs:z-0 xs:mt-2 divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
              props.autoWidth ? 'w-auto' : 'w-56'
            )}
          >
            <div className='px-1 py-1 '>
              {props.options.map((option, index) =>
                option.text === '_divider_' ? (
                  <div className='my-1 border-b border-gray-200' key={index} />
                ) : (
                  <Menu.Item key={index} disabled={option.disabled}>
                    {({ active }) => (
                      <button
                        type="button"
                        className={classNames(
                          option.disabled
                            ? 'text-gray-300 pointer-events-none'
                            : active ? 'bg-gray-100 text-black' : 'text-gray-900',
                          'group flex w-full items-center rounded-md px-2 py-2 whitespace-nowrap',
                          props.optionPosition?.length && `justify-${props.optionPosition}` 
                        )}
                        onClick={(e) => {
                          if (props.preventCloseOnClick) e.preventDefault()
                          props.setValue(option.value)
                        }}
                        style={{ background: (option.value === props.selectedValue || isHovered?.[index]) && props.secondaryColor, color: (option.value === props.selectedValue || isHovered?.[index]) && getTextColorBasedOnBackground(props.secondaryColor) }}
                        onMouseEnter={() => setIsHovered(prev => ({...prev, [index]: true}))}
                        onMouseLeave={() => setIsHovered(prev => ({...prev, [index]: false}))}
                      >
                        {option.icon && (
                          <span className='mr-2'>
                            <option.icon className='w-4 h-4' />
                          </span>
                        )}
                        {option.text}
                      </button>
                    )}
                  </Menu.Item>
                )
              )}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}

export default BookerDropdownButton
